module.exports = __webpack_public_path__ + "static/img/step2.f1d4373b.png";